import "@/styles/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexReactClient } from "convex/react";
import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { RouterProvider } from "@tanstack/react-router";
import { authClient } from "@/features/auth/lib/authClient";
import { LocaleProvider } from "@/shared/i18n";
import { env } from "@/shared/lib/env";
import { router } from "./router";

const convex = new ConvexReactClient(env.VITE_CONVEX_URL);

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  void navigator.serviceWorker
    .getRegistrations()
    .then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister())),
    );
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found.");
}

createRoot(rootEl).render(
  <StrictMode>
    <LocaleProvider>
      <ConvexBetterAuthProvider client={convex} authClient={authClient}>
        <RouterProvider router={router} />
      </ConvexBetterAuthProvider>
    </LocaleProvider>
  </StrictMode>,
);
